module.exports = __webpack_public_path__ + "static/media/ios_large_banner.ea8c14bf.jpg";